module.exports = __webpack_public_path__ + "assets/img/head_240word.285f7c7f.jpg";